import React ,{ useContext, useEffect , useState} from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
// import Royallogo from "../assets/RCI_Brand_Logo_2-Line_Horiz_White.png";
import '../singapore.css' ;
import { faStar} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BookingsPlan from "./BookingPackage";
import packagedata from "../components/SingaporePackagedata.jsx";
import Ovation1 from "../assets/iFly.jpg";
import Ovation2 from "../assets/BumperCars.jpg";
import Ovation3 from "../assets/FlowRider.jpg";
import Ovation4 from "../assets/indianfood.jpg";
import Ovation5 from "../assets/TWO70.jpg";
import Ovation6 from '../assets/ovation_experience.jpg';
import Interior1 from '../assets/OV_Interior.jpg';
// import Interior2 from '../assets/interior2.jpg';
import Ocean1 from '../assets/OV_oceanview.jpg';
// import Ocean2 from'../assets/ocean2.jpg';
import Balcony1 from "../assets/OV_Balcony.jpg";
// import Balcony2 from "../assets/balcony2.jpg";
// import Balcony3 from "../assets/balcony3.jpg";
import Suite1 from '../assets/RCI_OV_GrandLoftSuiteLiving.jpg';
import Suite2 from '../assets/RCI_OV_GrandLoftBal.jpg';
// import Suite3 from '../assets/RoyalLoftSuite-Balcony.jpg';
// import Suite4 from '../assets/RoyalLoftSuite-Bedroom.jpg';
import { faCircleCheck} from '@fortawesome/free-solid-svg-icons';
import whyusimage from '../assets/RCI_OV_Alaska_RET_Royal_CMYK (1).jpg';
import ScrolltoTop from "./ScrolltoTop.js";
import { ReactComponent as Next } from '../assets/next.svg';
import { ReactComponent as Pre } from '../assets/pre.svg';
// import SingaporeBanner from "../assets/singapore_banner.jpg";
import SingaporeBanner from "../assets/tirun_HNS_Banner.jpeg";
// import SingaporeBanner from "../assets/Singapore_new_banner.jpeg";
// import {Music4, PartyPopper , Utensils} from 'lucide-react';
import HSconcert from "../assets/hari&sukhmani.png";
import { CurrencyContext } from "./CurrencyContext.jsx";
// import { MousePointerClickIcon } from "lucide-react";

const dlink = {
  banner:{
    USD:"https://booking.tirun.com/swift/cruise/package/1512096--3-night-penang-cruise?siid=1035987&lang=1",
    INR:"https://booking.tirun.com/swift/cruise/package/1512096--3-night-penang-cruise?siid=1113842&lang=1"
    },
  Sailing:{
    USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&cruiseline=8&ship=13717&departureports=SIN&sortcolumn=price&sortorder=asc",
    INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&destinationtype=All&cruiseline=8&ship=13717&departureports=SIN&sortcolumn=price&sortorder=asc"
  },
  Ocean:{
  USD:"https://booking.tirun.com/swift/cruise?siid=1035987&searchcruise=1&cruiseline=8&departureports=SIN&destinations=19&startdate=10%2F01%2F2025&enddate=10%2F31%2F2025&durations=1-3&destinationtype=All",
  INR:"https://booking.tirun.com/swift/cruise?siid=1113842&searchcruise=1&cruiseline=8&departureports=SIN&destinations=19&startdate=10%2F01%2F2025&enddate=10%2F31%2F2025&durations=1-3&destinationtype=All"
  },
  Unit:{
    USD:"$700",
    INR:"₹60,000"
  },
  Book:{
  USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&ship=13717&departureports=SIN&sortColumn=price&sortOrder=asc",
  INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&destinationtype=All&CruiseLine=8&ship=13717&departureports=SIN&sortColumn=price&sortOrder=asc"
  }

  }


const Singapore =()=> {

  const Currency = useContext(CurrencyContext);


    const [index, setIndex] = useState(0); // initial slide index
    const [cardsPerView, setCardsPerView] = useState(3);
  
    // Array of only the selected deals
    const selectedDeals = [packagedata[0], packagedata[1], packagedata[2], packagedata[3] ];
  
    useEffect(() => {
      const updateCardsPerView = () => {
        setCardsPerView(window.innerWidth < 768 ? 1 : 4);
      };
      updateCardsPerView();
      window.addEventListener('resize', updateCardsPerView);
      return () => window.removeEventListener('resize', updateCardsPerView);
    }, []);
  
  
    const maxIndex = selectedDeals.length - cardsPerView;
  
    const handlePrev = () => {
      setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
    };
    
    const handleNext = () => {
      setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    };
  
    const visibleDeals = selectedDeals.slice(index, index + cardsPerView);


    return(
        <>
        <Navbar/>
        <div className="header">
                    <div className="offer-alert">
                        <div>
                            <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                            <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                            <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                            <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                            <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                        </div>
                        <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
                    </div>
                    </div>

        <div className="singapore-header">
        {/* <h2 className="main-heading">CRUISES FROM SINGAPORE</h2> */}
        <a href={dlink.banner[Currency.currencyCode]} target="_self"  >
        <img src={SingaporeBanner} alt="Singapore Banner"></img>
        </a>
        {/* <h2>GET 60% OFF ON SECOND GUEST</h2> */}
        {/* <h2 style={{marginTop:'-2vh'}}>KIDS SAIL FREE</h2> */}
        {/* <button>Request Quote</button> */}
        </div>


        <div className="sailing-container">

        <h4>All Sailings From Singapore,<br></br>

<span className="singapore-subheading">Starting From October 2025 to March 2026</span>

     {/* One     <MousePointerClickIcon className="mouseclick-icon" /> */}
     {/* <span className="click-design"></span> Away  */}
     </h4>

         <a href={dlink.Sailing[Currency.currencyCode]} target="_self"  >
            <button className="color-changing-button">View Now</button>
         </a>   
        
       

        </div>


        {/* Diwali Theme */}

        <div className="Diwalitheme">
          <h2>This Diwali, the festivities don't stop — it sets sail.</h2>
          <p>Join us from 27th to 30th October for a spectacular sailing packed with festive flair, electrifying entertainment, and mouthwatering Indian cuisine.</p>
        
         <div className="themecontentalign">

          <div className="themecontentleft">
            <h3>What Makes It Unmissable</h3>
            <div className="concert-icon">
              <div className="icon-circle1">
                  {/* <Music4 size={28} color="#ffffff" /> */}
                  </div>
                  <div>
            <h4>Live concert by Hari & Sukhmani</h4>
            <p>Experience two power-packed concerts on Day 1 & Day 3 by the beloved indie-folk duo, known for turning every show into a soulful celebration.</p>
            </div>
            </div>
            
             <div className="concert-icon"> 
              <div className="icon-circle2">
             {/* <PartyPopper size={30} color="#ffffff" /> */}
             </div>
             <div>
             <h4>Garba Night & Balloon Drop</h4>
             <p>Let the beats take over at our high-energy Garba night on Day 2— colourful, vibrant, and unforgettable.</p>
             </div>
             </div>
            
            <div className="concert-icon">
              <div className="icon-circle3">
              {/* <Utensils size={30} color="#ffffff"  /> */}
              </div>
              <div>
              <h4>Flavours That Feel Like Home</h4>
              <p>Indian Food Live Counters: Dosa (Breakfast & Dinner), Stuffed Paratha, Pani Puri<br></br>
            Traditional Desserts: Mysore Pak, Coconut Burfi, Gulab Jamun, Jalebi
            </p>
            </div>
              </div>
            
            </div>
            
            <div className="themecontentright">
              
              <img src={HSconcert} alt="Hari & Sukhmani Concert" />
              </div>

              </div> 


              <div className="themecta">
                <h4>Ocean view balcony starting at <span>{dlink.Unit[Currency.currencyCode]}</span> per person.</h4>
                  <a href={dlink.Ocean[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                
                <button>
  Book Now
  </button></a>

              </div>

        </div>



         <div className="sailing-container2">

        <h4>All Sailings From Singapore </h4>
        <h2>Starting from <span>October 2025 to March 2026</span> </h2>

         {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_term=undefined&utm_content=undefined&destinationtype=All&CruiseLine=8&ship=13717&departureports=SIN&sortColumn=price&sortOrder=asc" target="_self"  >
            <button>Book Now</button>
         </a>    */}

         </div>


        <div className="booking-package-container">
            {/* <h2>Book Your Cruise Now</h2> */}
            {/* <h2>More Singapore Sailings</h2> */}

            <div className="carousel-wrapper" style={{display:'flex',gap:'5vh' , marginTop:'5vh'}} >
                    <button onClick={handlePrev} style={{backgroundColor:'transparent',border:'none'}} >
                      <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
                    </button>
            
                    <div className="trip" style={{ display: 'flex', gap: '20vh' , transition: 'transform 0.5s ease-in-out'}}>
                       {visibleDeals.map((booking, i) => (
                      <a
                        key={i}
                        href={booking.link[Currency.currencyCode]}
                        target="_self"
                        rel="noopener noreferrer"
                        style={{ display:'flex',gap:'10vh' ,textDecoration: 'none' }}
                      >
                        <BookingsPlan Nights={booking.Nights} Destination={booking.Destination} DestinationImage={booking.DestinationImage} />
                      </a>
                    ))}
                    </div>

                    <button
                      onClick={handleNext} style={{backgroundColor:'transparent',border:'none'}} 
                    >
                     <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
                    </button>
                    
                    </div>
             </div>

            {/* <div>
            <BookingsPlan Nights={packagedata[0].Nights} Destination ={packagedata[0].Destination} DestinationImage={packagedata[0].DestinationImage}/>
            <BookingsPlan  Nights={packagedata[1].Nights} Destination ={packagedata[1].Destination} DestinationImage={packagedata[1].DestinationImage} />
            <BookingsPlan  Nights={packagedata[2].Nights} Destination ={packagedata[2].Destination} DestinationImage={packagedata[2].DestinationImage} />
            <BookingsPlan  Nights={packagedata[3].Nights} Destination ={packagedata[3].Destination} DestinationImage={packagedata[3].DestinationImage} />
            </div> */}
        {/* </div> */}

         <div className="Ovation-experience">
            <h3>#Just Cruise</h3>
            <h2>Exclusive Experiences On Ovation of the Seas </h2>

            <div className="royal-exp-card">
            <div className="experience">
            <img src={Ovation1} alt="royal-caribbean-experience" />
            <h4>I-FLY</h4>
            <p>With the wind in your face and no ground beneath your feet feel the adrenaline pumping.</p>
            </div>
            <div className="experience ">
            <img src={Ovation2} alt="royal-caribbean-experience" />
            <h4>BUMPER CARS</h4>
            <p>Fun for the the entire family on this timeless adventure activity onboard.</p>
            </div>
            <div className="experience">
            <img src={Ovation3} alt="royal-caribbean-experience" />
            <h4>FLOWRIDER</h4>
            <p>The surf's always up on the 40-foot-long FlowRider® surf simulator.</p>
            </div>
            </div>

            <div className="royal-exp-card card2" style={{marginTop:'15vh'}}>   
            <div className="experience">
            <img src={Ovation4} alt="royal-caribbean-experience"  />
            <h4>INDIAN FOOD</h4>
            <p>Get delicious Indian food onboard, so you're never too far from home.</p>
            </div>
            <div className="experience">
            <img  src={Ovation5} alt="royal-caribbean-experience" />
            <h4>TWO 70</h4>
            <p>Immerse yourself in a venue that changes form at different times of
            the day.</p>
            </div>
            <div className="experience">
            <img src={Ovation6} alt="royal-caribbean-experience" />
            <h4>NORTH STAR</h4>
            <p>360 degree views, 365 days a year on the highest observation point
            at sea.</p>
            </div>
            </div>
         </div>

         {/* Ovation Living */}

         <div className="Cabin-container Ovation-cabin" style={{marginTop:'15vh'}} >

            <h2>Accomodation</h2>

            <div className="Cabin laptop-repsonsive-cabin-royal">
            <div className="royal-cabin">


                {/* 1 */}
                
                <div className="cabin-category">  

                <div id="carouselExampleIndicators3" class="carousel slide  royal-category-carousel">


{/* <div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

{/* </div> */} 
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Interior1} class="d-block w-100" alt="..."  />
</div>

{/* <div class="carousel-item">
<img src={Interior2} class="d-block w-100" alt="..."  />
</div> */}
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Inside Cabin
                </div>
                </div>

                <div className="cabin-category"> 
                <div id="carouselExampleIndicators4" class="carousel slide">


{/* <div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

{/* </div> */}
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Ocean1} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Ocean2} class="d-block w-100" alt="..."  />
</div> */}
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div> 
                {/* <img src={Ocean} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Ocean View
                </div>
                </div>
            </div>

            <div className="royal-cabin">

            <div className="cabin-category">  
            <div id="carouselExampleIndicators5" class="carousel slide ">


{/* <div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

{/* </div> */}
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={Balcony1} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Balcony2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Balcony3} class="d-block w-100" alt="..." />
</div> */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Balcony
                </div>
                </div>

                <div className="cabin-category"> 
                <div id="carouselExampleIndicators6" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Suite1} class="d-block " alt="..."  />
</div>
<div class="carousel-item">
<img src={Suite2} class="d-block " alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Suite3} class="d-block " alt="..." />
</div>
<div class="carousel-item">
<img src={Suite4} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div> 
                {/* <img src={Suite} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Suite
                </div>

                </div>


            </div>

            </div>
            
        </div>


        {/* mobile accomodation */}

        <div className="mobile-accomodation-container singapore-accom">

        <div className="cabin-category mobile-responsive-royal-category">  

                <div id="carouselExampleIndicators7" class="carousel slide  royal-category-carousel">

{/* 
<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

{/* </div> */}
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Interior1} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Interior2} class="d-block w-100" alt="..."  />
</div> */}
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Inside Cabin
                </div>
                </div>

                <div className="cabin-category mobile-responsive-royal-category"> 
                <div id="carouselExampleIndicators8" class="carousel slide ">


{/* <div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

{/* </div> */}
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Ocean1} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Ocean2} class="d-block w-100" alt="..."  />
</div> */}
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Ocean} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Ocean View
                </div>
                </div>
                
            

                <div className="cabin-category mobile-responsive-royal-category">  
            <div id="carouselExampleIndicators9" class="carousel slide ">


{/* <div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

{/* </div> */}
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={Balcony1} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Balcony2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Balcony3} class="d-block w-100" alt="..." />
</div> */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    Balcony
                </div>
                </div>

                <div className="cabin-category mobile-responsive-royal-category"> 
                <div id="carouselExampleIndicators10" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Suite1} class="d-block " alt="..."  />
</div>
<div class="carousel-item">
<img src={Suite2} class="d-block " alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Suite3} class="d-block " alt="..." />
</div>
<div class="carousel-item">
<img src={Suite4} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div> 
                {/* <img src={Suite} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   Suite
                </div>
                </div>

</div>




        {/* Why Book Tirun */}

        <div className="Why-Container">

            <img src={whyusimage} alt="Ovation of the seas | Tirun"/>

            <div className="why-content">
            <h4>Make it memorable</h4>
            <h2 style={{fontWeight:'600'}}>Why Book with TIRUN</h2>
            <p>From the nervous first-timers to the second sea-animals, we have something to assist everybody.</p>

           <div className="why-bullet-points">

            <div style={{display:'flex', gap:'2vh'}}>
            <FontAwesomeIcon icon={faCircleCheck} style={{color:'#061236',fontSize:'2rem'}}  />  
            <div>
            <h4>30 Years of Experience</h4>
            <p>TIRUN brought the cruising life to India 30 years ago and we have what it takes to make your cruise trip memorable.</p>
            </div>
            </div>

            <div style={{display:'flex', gap:'2vh'}}>
            <FontAwesomeIcon icon={faCircleCheck} style={{color:'#061236',fontSize:'2rem'}}  />  
            <div>
            <h4>Best Price Guarantee</h4>
            <p>We guarantee you not just the best price but also multiple payment optionsto choose from and all this at a zero service charge to you.</p>
            </div>
            </div>

            <div style={{display:'flex', gap:'2vh'}}>
            <FontAwesomeIcon icon={faCircleCheck} style={{color:'#061236',fontSize:'2rem'}}  />
            <div>
            <h4>Easy Cancellation</h4>
            <p>Hold a stateroom for free for up to 48 hrs, while you decide you holiday and enjoy customized relaxed cancellation term, to suit your needs.</p>
            </div>
            </div>

           </div>
           </div>
        </div>




        <a href={dlink.Book[Currency.currencyCode]} target="_self" className="book-singapore-link"><h3 className="book-container">Book Your Singapore Cruise Now ! </h3></a>

        <ScrolltoTop/>
        <Footer/>
        </>
    );

}

export default Singapore;